import { provideEffects } from '@ngrx/effects';

import { StorePersistEffects } from './store-persist.effects';

export function provideRootStateStorage() {
    return [provideEffects([StorePersistEffects])];
}
